export const HERO_IMG = "https://images.unsplash.com/photo-1763750581767-b367bcd6c117?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxvdmVyc2l6ZWQlMjBzdHJlZXR3ZWFyJTIwdC1zaGlydCUyMG1vZGVsJTIwZGFya3xlbnwwfHx8fDE3NzczMTQ2NTJ8MA&ixlib=rb-4.1.0&q=85";

export const CATEGORY_IMAGES = {
  men: "https://images.unsplash.com/photo-1721352490417-3e96bbf0ba84?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxvdmVyc2l6ZWQlMjBzdHJlZXR3ZWFyJTIwdC1zaGlydCUyMG1vZGVsJTIwZGFya3xlbnwwfHx8fDE3NzczMTQ2NTJ8MA&ixlib=rb-4.1.0&q=85",
  women: "https://images.unsplash.com/photo-1776466333828-bdf98c44eaf3?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2luZW1hdGljJTIwdXJiYW4lMjBmYXNoaW9uJTIwbmlnaHR8ZW58MHx8fHwxNzc3MzE0NjY2fDA&ixlib=rb-4.1.0&q=85",
  couple: "https://images.pexels.com/photos/11871927/pexels-photo-11871927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  oversized: "https://images.pexels.com/photos/28758240/pexels-photo-28758240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  graphic: "https://images.pexels.com/photos/37014370/pexels-photo-37014370.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  anime: "https://images.pexels.com/photos/9637851/pexels-photo-9637851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
};

export const GALLERY_IMGS = [
  "https://images.pexels.com/photos/19101424/pexels-photo-19101424.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.pexels.com/photos/28758240/pexels-photo-28758240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.pexels.com/photos/9637851/pexels-photo-9637851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.pexels.com/photos/37014370/pexels-photo-37014370.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.pexels.com/photos/11871927/pexels-photo-11871927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600",
  "https://images.unsplash.com/photo-1721352490417-3e96bbf0ba84?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxvdmVyc2l6ZWQlMjBzdHJlZXR3ZWFyJTIwdC1zaGlydCUyMG1vZGVsJTIwZGFya3xlbnwwfHx8fDE3NzczMTQ2NTJ8MA&ixlib=rb-4.1.0&q=85",
];

export const REVIEWS = [
  {
    name: "Aarav Sharma",
    city: "Mumbai",
    rating: 5,
    body: "The fabric is insanely thick. Feels like a Rs. 2000 tee. Already ordered 3 more.",
    img: "https://images.pexels.com/photos/28758240/pexels-photo-28758240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300",
  },
  {
    name: "Priya Mehta",
    city: "Bangalore",
    rating: 5,
    body: "Loved the oversized fit. Finally a brand that gets streetwear right.",
    img: "https://images.pexels.com/photos/19101424/pexels-photo-19101424.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300",
  },
  {
    name: "Karan Singh",
    city: "Delhi",
    rating: 5,
    body: "COD worked perfectly. Delivered in 3 days. Crazy quality at this price.",
    img: "https://images.pexels.com/photos/9637851/pexels-photo-9637851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300",
  },
];
